export const RESET = 'EXCMUSERDATAWORKPLACE_LIST_RESET'
export const SET_ITEMS = 'EXCMUSERDATAWORKPLACE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMUSERDATAWORKPLACE_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMUSERDATAWORKPLACE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMUSERDATAWORKPLACE_LIST_TOGGLE_LOADING'
